angular
    .module('goodPriceAccordion.components', [])
    .component('goodPriceAccordion', {
        templateUrl: 'ng/components/goodPriceAccordion/goodPriceAccordion.view.html',
        bindings: {
            /** Input data **/
            onRentCalculated: '&?',
            instantModel: '<',
            identifierAppVendor: '<',
            operationType: '<'
        },
        controllerAs: 'ordergoodPriceAccordionCtrl',
        controller: function orderCtrl($instantService, Rata) {

            var self = this;
            self.product = {};
            console.log(self.product);
            self.$onInit = function () {
                self.rata = {};
                self.durata = 0;
                self.listVr = {};
                self.valoreSelezionato = 0;
                self.controllo = false;
                self.totalRate = [];
                self.operationType = self.operationType || null;
                self.minimo = 0;
                self.massimo = 0;
                self.passo = 0;
                self.titolo = 'LE MIE RATE';
                self.arrFrequencyType = ['MENSILE', 'BIMESTRALE', 'TRIMESTRALE'];
                if (self.instantModel.rata.price) {
                    const month = self.instantModel.rata.month;
                    self.valoreSelezionato = month;
                    var tempo = "";
                    switch (self.instantModel.rata.frequencyType) {
                        case 1:
                            tempo = "MENSILE";
                            break;
                        case 2:
                            tempo = "BIMESTRALE";
                            break;
                        case 3:
                            tempo = "TRIMESTRALE";
                            break;

                    }

                    self.calculatingFrequencyRent(tempo)
                        .then(function (resp) {

                        })
                        .catch(function (err) {
                            console.log('Errore nella chiamata: ', err);
                        })
                        .finally(function () {
                            self.onchange(month);
                            return;
                        });


                } else {
                    self.instaLeasingPrice = null;
                    self.canone = '';
                    self.productPicks = [];
                    self.optionSelect = [{
                            'nome': '10% del totale'
                        },
                        {
                            'nome': '15% del totale'
                        },
                        {
                            'nome': '25% del totale'
                        },
                        {
                            'nome': '30% del totale'
                        },
                        {
                            'nome': '50% del totale'
                        }
                    ];

                    $instantService.newCalculatorRend(self.instantModel.listAppProduct,
                            self.instantModel.leasingPrice,
                            self.instantModel.appPriceList,
                            self.instantModel.listAppProduct[0].idUser)
                        .then(function (response) {
                            console.log(response);
                            self.totalRate = response.listLeasingPrice && response.listLeasingPrice.sort(function (a, b) {
                                if (a.month < b.month) {
                                    return -1
                                } else {
                                    return 1
                                }
                            });
                            console.log('Calculator Rend ordered: ', self.totalRate)
                            self.listVr = response.listVr;
                            self.idListino = response.leasingPrice.listPriceList[0].id
                            self.minimo = response.listLeasingPrice && response.listLeasingPrice[0].month;
                            self.massimo = response.listLeasingPrice && response.listLeasingPrice[response.listLeasingPrice.length - 1].month;
                            self.passo = 6;
                            self.canone = 'MENSILE';
                        })
                        .catch(function (err) {
                            console.log(err)
                        })
                        .finally(function () {
                            self.controllo = true;

                        });

                }
            }
            self.calculatingFrequencyRent = function (elem) {
                self.canone = elem;
                console.log("Canone selezionato: ", self.canone);
                if (elem == "MENSILE") {
                    self.instantModel.appPriceList.pSecondo = 1;
                } else if (elem == "BIMESTRALE") {
                    self.instantModel.appPriceList.pSecondo = 2;
                } else {
                    self.instantModel.appPriceList.pSecondo = 3;
                }

                return $instantService.newCalculatorRend(self.instantModel.listAppProduct,
                        self.instantModel.leasingPrice,
                        self.instantModel.appPriceList,
                        self.instantModel.listAppProduct[0].idUser)
                    .then(function (response) {
                        console.log(response);
                        self.totalRate = response.listLeasingPrice && response.listLeasingPrice.sort(function (a, b) {
                            if (a.month < b.month) {
                                return -1
                            } else {
                                return 1
                            }
                        });
                        self.listVr = response.listVr;
                        self.idListino = response.leasingPrice.listPriceList[0].id
                        self.minimo = response.listLeasingPrice && response.listLeasingPrice[0].month;
                        self.massimo = response.listLeasingPrice && response.listLeasingPrice[response.listLeasingPrice.length - 1].month;

                        self.passo = 6;
                        //self.instaLeasingPrice.price = self.totalRate[0].price | self.durata;
                        self.instaLeasingPrice = self.totalRate.find(function (element) {
                            return element.month == self.durata;
                        })
                        console.log("La lunghezza dell'array: ", response.listLeasingPrice.length)
                        //self.instaLeasingPrice = response.listLeasingPrice[Math.ceil(response.listLeasingPrice.length / 2) + 1];
                    })
                    .catch(function (err) {
                        console.log(err)
                    })
                    .finally(function () {
                        self.controllo = true;
                        self.canone = elem;

                    });


            }

            self.selectedChoise = function (item) {
                console.log('valore selezionato: ', item);
                Object.assign(self.rata, {
                    'vr': self.listVr[value]
                })
            }

            self.onchange = function (value) {
                self.durata = value;
                console.log('Ho cambiato valore', value);
                self.instaLeasingPrice = self.totalRate.find(function (elem) {

                    return elem.month == value;

                })
                self.rata = self.totalRate.find(function (elem) {

                    return elem.month === value;
                });

                Object.assign(self.rata, {
                    'vr': self.listVr[value]
                })
                Object.assign(self.rata, {
                    'type': self.instantModel.operationType
                })
                Object.assign(self.rata, {
                    'idListino': self.idListino
                })
                self.onRentCalculated({
                    value: self.rata
                });
            }
        }
    });